var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #1f1f1f;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21142",
    "data-name": "Group 21142",
    transform: "translate(12933 20397)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_409",
    "data-name": "Ellipse 409",
    className: "cls-1",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(-12933 -20397)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21035",
    "data-name": "Group 21035",
    transform: "translate(-12924.818 -20388.82)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18231",
    "data-name": "Rectangle 18231",
    className: "cls-2",
    width: 2.143,
    height: 17.143,
    rx: 1.071,
    transform: "translate(0 1.515) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18232",
    "data-name": "Rectangle 18232",
    className: "cls-2",
    width: 2.143,
    height: 17.143,
    rx: 1.071,
    transform: "translate(12.123 0.001) rotate(45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon_close.3a3792bae2fa9384318460b8b1b7e766.svg";
export { ForwardRef as ReactComponent };